import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { transformDeprecatedSizeValues, useLinkBehavior } from '../shared';
import { getThemeConfig, PrimaryStyledLink, RepositionedChevron } from '../styles';
var ChevronLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var dataTest = _ref['data-test'],
      _ref$chevronDirection = _ref.chevronDirection,
      chevronDirection = _ref$chevronDirection === void 0 ? 'right' : _ref$chevronDirection,
      _ref$chevronPosition = _ref.chevronPosition,
      chevronPosition = _ref$chevronPosition === void 0 ? 'right' : _ref$chevronPosition,
      children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      theme = _ref.theme,
      linkProps = _objectWithoutProperties(_ref, ["data-test", "chevronDirection", "chevronPosition", "children", "size", "theme"]);

  var _useLinkBehavior = useLinkBehavior(linkProps),
      linkBehavior = _extends({}, _useLinkBehavior);

  var componentTheme = useComponentTheme({
    name: 'Link',
    theme: getThemeConfig(theme)
  }); // This is for backward compatibility - need to remove this once everyone moved to new size props

  size = transformDeprecatedSizeValues(size);
  return /*#__PURE__*/React.createElement(PrimaryStyledLink, _extends({}, linkProps, linkBehavior, {
    customTheme: componentTheme,
    "data-test": dataTest ? dataTest : undefined,
    ref: ref,
    size: size
  }), chevronPosition === 'left' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RepositionedChevron, {
    pointing: chevronDirection,
    position: chevronPosition,
    size: componentTheme[size].iconSize,
    "aria-hidden": true
  }), children) : /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(RepositionedChevron, {
    pointing: chevronDirection,
    position: chevronPosition,
    size: componentTheme[size].iconSize,
    "aria-hidden": true
  })));
});
ChevronLink.displayName = 'ChevronLink';
export default ChevronLink;